import {formatPhone} from '@deliveriesondemand/dod-utils';

import Service from './Service';
import NavigationService from './NavigationService';
import ServiceFaker from '-/services/ops/Faker';
import {get, isEmpty, set as lodashSet} from '-/util/lodash';

const CLEAR_COAPP = 'CLEAR_COAPP';
const EMPLOYMENTINFO_SET = 'EMPLOYMENTINFO_SET';
const EMPLOYMENTINFO_SETDATA = 'EMPLOYMENTINFO_SETDATA';

const reducerName = 'employmentInfo';

const employmentInfoDefaultState = {
    status: 'employed',
    netOrGross: 'gross',
    yearsWorked: '',
    monthsWorked: '',
    employerName: '',
    employerAddress: {},
    employerPhone: '',
    position: '',
    pay: {
        payType: 'salary',
        rate: undefined,
        per: 'year',
        hoursPerWeek: undefined
    },
    priorEmployment: [],
    provideSelfEmploymentVerification: undefined
};

const initialState = {
    employmentInfo: {
        ...employmentInfoDefaultState,
        ...ServiceFaker.employmentInfo
    },
    employmentInfo_CoApp: {...employmentInfoDefaultState}
};

const set = (state, key, value) => {
    const rootProperty = NavigationService.isCoApplicant() ? 'employmentInfo_CoApp' : 'employmentInfo';
    const newState = {
        ...state
    };

    lodashSet(newState, `${rootProperty}.${key}`, value);
    
    return newState;
};

const reducer = (state = initialState, action) => {
    const {type, payload} = action;
    switch (type) {
        case CLEAR_COAPP: {
            return {
                ...state,
                employmentInfo_CoApp: {
                    ...employmentInfoDefaultState
                }
            };
        }
        case EMPLOYMENTINFO_SETDATA: {
            const {employmentInfo, employmentInfo_CoApp} = payload;
            return {
                ...state,
                employmentInfo: {
                    ...state.employmentInfo,
                    ...employmentInfo
                },
                employmentInfo_CoApp: {
                    ...state.employmentInfo_CoApp,
                    ...employmentInfo_CoApp
                }
            };
        }
        case EMPLOYMENTINFO_SET: {
            const {key, value} = payload;
            
            return set(state, key, value);
        }
    }
    return state;
};

class EmploymentInfoService extends Service {
    constructor() {
        super();

        if (!EmploymentInfoService.instance) {
            EmploymentInfoService.instance = this;
        }
        return EmploymentInfoService.instance;
    }

    clearCoApplicant() {
        this.store.dispatch({
            type: CLEAR_COAPP
        });
    }

    getReducerName() {
        return reducerName;
    }

    getReducer() {
        return reducer;
    }

    getKeyName() {
        return `employmentInfo${NavigationService.isCoApplicant() ? '_CoApp' : ''}`;
    }

    getEmploymentInfoForCurrentApplicant() {
        return this.getReducerState()[this.getKeyName()];
    }

    set(key, value) {
        this.store.dispatch({
            type: EMPLOYMENTINFO_SET,
            payload: {
                key,
                value
            }
        });
    }

    setData(data) {
        const {employmentInfo, employmentInfo_CoApp} = data;
        const formatData = info => {
            if (info.employerPhone) {
                info.employerPhone = formatPhone(info.employerPhone, true);
            }
        };

        if (employmentInfo) {
            formatData(employmentInfo);
        }

        if (employmentInfo_CoApp) {
            formatData(employmentInfo_CoApp);
        }

        this.store.dispatch({
            type: EMPLOYMENTINFO_SETDATA,
            payload: {
                employmentInfo,
                employmentInfo_CoApp
            }
        });
    }

    getDataForSave() {
        let employmentInfo = {...this.getEmploymentInfoForCurrentApplicant()};

        if (isEmpty(employmentInfo)) {
            return {[this.getKeyName()]: employmentInfo};
        }

        const defaultToZero = ['yearsWorked', 'monthsWorked'];

        defaultToZero.forEach(key => {
            const value = get(employmentInfo, key, '');
            if (!value || isNaN(value)) {
                lodashSet(employmentInfo, key, 0);
            }
        });

        if (employmentInfo.pay) {
            const hoursPerWeek = parseInt(get(employmentInfo, 'pay.hoursPerWeek'));
            const rate = parseFloat(get(employmentInfo, 'pay.rate'));

            if (isNaN(hoursPerWeek)) {
                delete employmentInfo.pay.hoursPerWeek;
            } else {
                lodashSet(employmentInfo, 'pay.hoursPerWeek', hoursPerWeek);
            }

            if (isNaN(rate)) {
                delete employmentInfo.pay.rate;
            } else {
                lodashSet(employmentInfo, 'pay.rate', rate);
            }
        }

        if (employmentInfo.priorEmployment) {
            const [priorEmploymentArray] = employmentInfo.priorEmployment;
            if (priorEmploymentArray && !priorEmploymentArray.priorEmployerName) {
                employmentInfo.priorEmployment.splice(0, 1);
            }
        }
        if (!employmentInfo.dutyTransferExpected) {
            delete employmentInfo.dutyTransferWhere;
            delete employmentInfo.dutyTransferWhen;
        }
        if (employmentInfo.pay.payType === 'hourly') {
            delete employmentInfo.pay.per;
        }

        if (employmentInfo.pay.per === 'year') {
            delete employmentInfo.pay.hoursPerWeek;
        }

        if (employmentInfo.status === 'retired' || employmentInfo.status === 'other') {
            delete employmentInfo.pay;
            delete employmentInfo.yearsWorked;
        }

        return {[this.getKeyName()]: employmentInfo};
    }
}

export default new EmploymentInfoService();
